import loadjs from "shared/util/loadjs";

const OneTrust = {
	CATEGORY: {
		NECESSARY: "1",
		PERFORMANCE: "2",
		FUNCTIONAL: "3",
		ADVERTISING: "4",
	},
	loadScript: (url, category) => {
		if (window.oneTrustLoadJS) {
			return new Promise((resolve) => {
				window.oneTrustLoadJS(url, category, resolve);
			});
		} else {
			// Optimistically still load the JS if we don't have OneTrust
			return loadjs(url);
		}
	},
};

export default OneTrust;



// WEBPACK FOOTER //
// ./src/shared/util/oneTrust.js